/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnswerOption } from './answerOption';


/**
 * Добавить вопрос
 */
export interface AddQuestion { 
    /**
     * ID фотографии вопроса.
     */
    photoId?: string;
    /**
     * 
     */
    answerTypeId?: number;
    /**
     * 
     */
    sortOrder?: number;
    /**
     * Идентификатор опроса
     */
    pollId?: string;
    /**
     * Вопрос.
     */
    text?: string;
    /**
     * Список вариантов ответов
     */
    answers?: Array<AnswerOption>;
}

